
<template>
  <v-btn v-if="IsLoading" icon class="align-self-center" :small="size === 'small'">
    <v-progress-circular indeterminate size="24" width="2" :color="color ? color : 'primary'">
    </v-progress-circular>
  </v-btn>
  <div v-else class="align-self-center">
    <v-progress-circular v-show="autoTimer && !tempicon" :value="100 - elapsedWaitPercent" size="28" width="7"
      color="#00000008" style="position: absolute;">
    </v-progress-circular>
    <v-tooltip bottom :disabled="!tip">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon :small="size === 'small'" :color="iconcolor" @click="action()">
          <v-icon v-text="tempicon ? tempicon : (icon ? icon : 'mdi-refresh')" />
        </v-btn>
      </template>
      <span v-text="tip" />
    </v-tooltip>
  </div>
</template>


<script>
export default {
  name: "RefreshDataBtn",
  props: {
    method: [String, Function],
    externalLoading: Boolean,
    size: String,
    color: String,
    icon: String,
    tip: String,
    autoTimer: Number,
  },

  data() {
    return {
      tempicon: null,
      loading: false,
      autoUpdater: null,

      elapsedWait: 0,
      elapsedWaitPercent: 0,
    };
  },

  mounted() {
    this.elapsedWait = this.autoTimer;
    this.startTimer();
  },

  beforeDestroy() {
    if (this.autoUpdater) {
      this.stopTimer();
    }
  },

  methods: {
    async excecutable() {
      if (typeof this.method === 'string' || this.method instanceof String) {
        return this.$store.dispatch(this.method)
      }
      else {
        return this.method()
      }
    },

    async action() {
      this.elapsedWait = 0;
      this.elapsedWaitPercent = 0;
      if (!this.IsLoading) {
        this.loading = true;

        await this.excecutable()
          .then(() => {
            this.tempicon = "mdi-check";
            setTimeout(() => {
              this.tempicon = null;
            }, 1000);
          })
          .catch(() => {
            this.tempicon = "mdi-close";
            this.stopTimer();
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        console.error(this.method, "denied refresh");
      }

    },

    startTimer() {
      if (this.autoTimer) {
        //console.log('started refersh timer ', this.method);
        this.autoUpdater = setInterval(() => {
          this.elapsedWait = this.elapsedWait + 1000;
          this.elapsedWaitPercent = (this.elapsedWait / this.autoTimer) * 100;
          if (this.elapsedWait >= this.autoTimer && !this.IsLoading) {
            this.action();
          }
        }, 1000);
      }
    },

    stopTimer() {

      clearInterval(this.autoUpdater);
      this.loading = false;
      this.elapsedWait = 0;
      this.elapsedWaitPercent = 0;
    },
  },

  computed: {
    IsLoading() {
      return this.loading || this.externalLoading;
    },

    iconcolor() {
      if (this.tempicon != null) {
        return this.tempicon === "mdi-check" ? "green" : "error";
      } else {
        return this.color;
      }
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped></style>